import { render, staticRenderFns } from "./RelatedServiceRequests.vue?vue&type=template&id=7767d3a8&"
import script from "./RelatedServiceRequests.vue?vue&type=script&lang=js&"
export * from "./RelatedServiceRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports